import React, { useEffect, useState } from "react";
import { Grid, Box } from '@mui/material';
import { BasicCard } from "../../shared/basicCard";
import { BasicErrorLabel } from "../../shared/basicErrorLabel";
import {  updateTeamNameApi } from "../../api/orgSeasonApi";
import { BasicTextBox } from "../../shared/basicTextBox";
import { useOrgSeasonContext } from "../../context/orgSeasonContext";
import { BasicButton } from "../../shared/basicButton";
import { useApiCallWithAuth } from "../../hooks/useApiCallWithAuth";
import { Team } from "../../api/models/team";

export interface ManageNamePanelProps {
    team: Team; 
}

export function ManageNamePanel(props: ManageNamePanelProps) {

    const [newTeamName, setNewTeamName] = useState<string>(props.team.name || '');

    const [errorMessage, setErrorMessage] = useState<string>('');
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const updateTeamNameApiRequest = useApiCallWithAuth(updateTeamNameApi);
   
    const { orgSeason, refreshOrgSeason } = useOrgSeasonContext();

    //update the local value for the name
    function handleUpdateTeamName(e: React.ChangeEvent<HTMLInputElement>) {
       setNewTeamName(e.target.value);
    }

    //change the orgSeason name
    async function updateData() {

        if (!newTeamName) {
            setErrorMessage('required');
            return;
        }

        const updateDataItem = { name: newTeamName };
        try{
            await updateTeamNameApiRequest.request(orgSeason?.id, props.team.id, updateDataItem);
            refreshOrgSeason();
        }
        catch(error){
            console.error("Error updating team name:", error);
            setErrorMessage("Failed to update team name. Please try again.");
        }
        
    }

    return (<>
        <Grid container spacing={3} alignItems="center">
            <Grid item><h3>Update Name</h3></Grid>
        </Grid>
        <BasicCard>

            {orgSeason &&
                <Box>
                    <Grid container spacing={1} >
                        <Grid>
                            <BasicTextBox id='txtTeamName'
                                label='Team Name*'
                                errorMessage={errorMessage}
                                maxLength={20}
                                width={250}
                                value={newTeamName}
                                onChange={handleUpdateTeamName} />
                        </Grid>

                        <Grid>
                            <BasicButton onClick={updateData} labelText="Update" />

                        </Grid>

                    </Grid>
                    {errorMessage && <BasicErrorLabel errors={[errorMessage]} />}
                </Box>
            }
        </BasicCard>
    </>
    );
}
